module.exports = __webpack_public_path__ + "img/965146_2B191D_DF7A5C_BFD6E1-256px.39211053.png";